import React from "react";
import SignUpForm from "./SignUpForm";
import { useErrorHandler } from "react-error-boundary";
import { useMutation } from "react-query";
import { submitSignUpForm } from "../../../queries/session";
import { createErrors } from "../../../queries/helpers";
import PropTypes from "prop-types";
import queryString from "query-string";
import isEmpty from "lodash/isEmpty";

const SignUpPage = ({ history }) => {
  const handleError = useErrorHandler();
  const signUp = useMutation(async (formData) => {
    await submitSignUpForm(formData);
  });

  const onSubmit = async (values) => {
    let formData = values;
    const params = queryString.parse(location.search);
    if (!isEmpty(params.token)) {
      formData = { ...values, inviteToken: params.token };
    } else {
      formData = values;
    }
    formData.password_confirmation = formData.password;
    return await signUp
      .mutateAsync(formData)
      .then(() => {
        history.push("/confirm-email");
      })
      .catch((error) => {
        return createErrors(error, "Sign failed", handleError);
      });
  };

  return (
    <div className="fs-wrap fs-form">
      <SignUpForm onSubmit={onSubmit} />
    </div>
  );
};

SignUpPage.propTypes = {
  history: PropTypes.object.isRequired,
};

export default SignUpPage;
